export default __webpack_public_path__ + "static/media/Lucifer2.71853a1e.png";